import type { Action } from 'redux';
import type { GetGoogleAccountsPayload } from '../GoogleMarketingPlatform.types';
import { ReduxAsyncAction } from '../../../../../services/ReduxAsyncAction';
import dash_api from '../../../../../../main/support/dash_api';

const GetGoogleMarketingAccounts = new ReduxAsyncAction<'GET_GOOGLE_MARKETING_ACCOUNTS', void, GetGoogleAccountsPayload>(
  'GET_GOOGLE_MARKETING_ACCOUNTS'
);
GetGoogleMarketingAccounts.registerRequest(() => {
  return dash_api.get('/v1/google/marketing/ad-accounts').then(({ data }) => {
    return {
      accounts: Array.isArray(data) ? data : [],
    };
  });
});
export const GET_GOOGLE_MARKETING_ACCOUNTS = GetGoogleMarketingAccounts.actionNamespaceConstants;
export const getGoogleMarketingAdAccounts = GetGoogleMarketingAccounts.request;

export type GetGoogleMarketingAdAccountsAction = Action<
  typeof GET_GOOGLE_MARKETING_ACCOUNTS.response | typeof GET_GOOGLE_MARKETING_ACCOUNTS.request
> & {
  data: GetGoogleAccountsPayload;
};
